<template>
  <div class="fixed max-w-xs w-full rounded-t bottom-0 right-1/4 transform translate-x-1/2 shadow overflow-hidden">
    <div class="py-2 px-3 bg-gray-700 text-white flex items-center justify-between">
      <div>
        <span class="mr-2">Status:</span>
        <span>{{ getConsoleStatus }}</span>
      </div>
      <button v-if="!consoleExpanded" class="bg-gray-500 px-4 py-3 text-sm rounded-lg" @click="toggleConsole">
        <ChevronUp />
      </button>
      <button v-else class="bg-gray-500 px-4 py-3 text-sm rounded-lg" @click="toggleConsole">
        <ChevronDown />
      </button>
    </div>

    <template v-if="consoleExpanded">
      <Dialpad />
    </template>
    <div v-for="call in activeCalls" :key="call.callSid" class="bg-white divide-y divide-gray-200">
      <call-incoming v-if="call.type === 'incoming'" :call="call" />
      <call-outgoing v-if="call.type === 'outgoing'" :call="call" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default {
  setup () {
    const callConsole = useCallConsoleStore()
    return { callConsole }
  },
  data () {
    return {
      consoleExpanded: false,
      number: ''
    }
  },
  computed: {
    ...mapState(useCallConsoleStore, [
      'isConsoleReadyForCalls',
      'getConsoleStatus',
      'activeCalls'
    ])
  },
  async mounted () {
    // Only initialize if user is authenticated
    const { loggedIn } = useAuth()
    if (loggedIn.value) {
      await this.callConsole.initialiseDevice()
    }
  },
  methods: {
    toggleConsole () {
      this.consoleExpanded = !this.consoleExpanded
    },
    inputDigit (digit) {
      this.number = this.number + digit
    }
  }
}

</script>
